angular.module('unergie.main')
.controller('toolsCtrl', ($scope, $state, $sce, BoFeaturesService, ApiUser, ApiContent, ApiContentSearch, TogglerUtils, ErrorCatcher, APIExternalLbp) => {
    $scope.isActive = (state) => $state.is(state)
    $scope.diabolocom = {
        urlPrefix: '/info/CLB7BY9F7',
    }

    $scope.isPlum = TogglerUtils.isPlum()

    const formUrlSuffix = `/api-user/lbp/authenticate`

    $scope.formUrl = ''
    if (window.location.hostname.includes('local.')) {
        $scope.formUrl = `${formUrlSuffix}`
    } else if (window.location.hostname.includes('.int.')) {
        $scope.formUrl = `https://espace-client.int.plum.fr${formUrlSuffix}`
    } else if (window.location.hostname.includes('.preprod.')) {
        $scope.formUrl = `https://espace-client.preprod.plum.fr${formUrlSuffix}`
    }

    $scope.trustSrc = (src) => {
        return $sce.trustAsResourceUrl(src)
    }

    $scope.tokenContent = `{
    "data1":"002827100",
    "data2":"1",
    "data3":"SICLON",
    "data4":"DJOURA",
    "data5":"01/02/2001",
    "data6":"Pedropoulpos@unergie.com",
    "data7":"0804172833",
    "data8":"MR SICLON DJOURA",
    "data9":"",
    "data10":"",
    "data11":"160 RUE DES SOUBEYRANNES",
    "data12":"",
    "data13":"38710",
    "data14":"LAVARS",
    "sub":"Fournisseur C)nergie verte",
    "iss":"lbp",
    "aud":"plu"
}`

    $scope.isFeatureOn = BoFeaturesService.isFeatureOn

    $scope.encryptToken = ($event) => {
        console.log($scope.tokenContent)
        $scope.encrypting = true
        return APIExternalLbp.encryptToken({ token: $scope.tokenContent }).$promise.then((result) => {
            $scope.cipheredTokenContent = result.token
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.encrypting = false
        })
    }

    $scope.mockDiabolocomFakeCall = () => {
        $scope.faking = true
        return ApiUser.mockDiabolocomFakeCall().$promise
        .then((result) => {
            $scope.diabolocomCallId = result.diabolocomCallId
            $scope.diabolocomQueryParams = `diabolocomCallId=${result.diabolocomCallId}`
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.faking = false
            $scope.refreshDiabolocomCallList()
        })
    }

    $scope.refreshDiabolocomCallList = () => {
        $scope.refreshingCalls = true
        return ApiContentSearch({ orderBy: '-answered_at', gte: `answered_at=${moment().startOf('day').unix()}` })
        .searchPaginated({ resource: 'client-contacts-phone', status: 'answered' }).$promise
        .then((results) => {
            $scope.diabolocomCalls = results.results
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshingCalls = false
        })
    }

    $scope.markDiabolocomCallFinished = (id) => {
        return ApiContent.updateClientContactPhone({ id }, { status: 'done' }).$promise
        .then((results) => {
            $scope.refreshDiabolocomCallList()
        })
        .catch(ErrorCatcher)
    }
})
